// extracted by mini-css-extract-plugin
export default {"HistoryBetInfoContainer":"u0_u1","HistoryBetInfoContainer_drawer":"u0_va","HistoryBetInfo":"u0_vb","table":"u0_vc","table_head":"u0_ve","win":"u0_uK","refunded":"u0_uO"};